import { RootState } from '../types';

export const selectZoneInfo = (state: RootState) => state.zoneStore.zoneInfo;

export const selectZone = (state: RootState) => state.zoneStore.zone;
export const selectMetropolitanArea = (state: RootState) =>
  state.zoneStore.zone.area;
export const selectMedianZone = (state: RootState) =>
  state.zoneStore.zone.middleZone;
